import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    '&&': {
      paddingTop: theme.spacing(10),
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    gap: theme.spacing(10),
    height: '100%',
  },

  top: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  profile: {
    display: 'flex',
    alignItems: 'center',

    gap: theme.spacing(3),
  },

  icon: {
    width: 48,
    minWidth: 48,
  },

  address: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },

  shareButton: {
    minWidth: 120,
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },
  },

  explore: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  exploreInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },

  exploreButton: {},
}));
